<div class="selector-wrapper">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search by Status Name</mat-label>
    <input matInput [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
      placeholder="Enter referral, group, sub-group, or code...">
    <mat-icon matSuffix style="color: #1363DF;" *ngIf="!searchText">search</mat-icon>
    <button *ngIf="searchText" mat-icon-button matSuffix (click)="searchText=''; onSearchChange()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <div class="expand-all-container" *ngIf="showCheckboxes">
    <button mat-button (click)="toggleAllPanels()">
      {{ allExpanded ? 'Collapse All' : 'Expand All' }}
    </button>
  </div>

  <div class="list-container">
    <cdk-virtual-scroll-viewport itemSize="48" class="status-list-viewport" minBufferPx="100" maxBufferPx="200">
      <div *cdkVirtualFor="let item of flatHierarchy; let i = index; trackBy: trackByItem">

        <ng-container [ngSwitch]="item.type">

          <div *ngSwitchCase="'referral'" class="list-row referral-row" [class.expanded]="item.isExpanded"
            (click)="toggleExpansion(item)">
            <div class="list-content">
              <mat-checkbox *ngIf="showCheckboxes" [(ngModel)]="item.checked" [indeterminate]="item.indeterminate"
                (ngModelChange)="onReferralCheckboxChange(asReferral(item), $event)" (click)="$event.stopPropagation()"
                style="margin-bottom:0">
              </mat-checkbox>

              <ng-container *ngIf="showColorPickers">
                <input *ngIf="allowColorChange; else staticReferralColor" class="color-input"
                  [style.background]="item.color" [(colorPicker)]="item.color"
                  (colorPickerChange)="onReferralColorChange(asReferral(item), $event)" [cpUseRootViewContainer]="true"
                  [cpPosition]="getPickerPosition(i)" [cpPositionRelativeToArrow]="true"
                  (click)="$event.stopPropagation()" readonly />
                <ng-template #staticReferralColor>
                  <div class="color-input static" [style.background]="item.color"></div>
                </ng-template>
              </ng-container>

              <span class="referral-name">{{ item.name | titlecase }}</span>
            </div>
            <mat-icon class="chevron-icon">keyboard_arrow_down</mat-icon>
          </div>

          <div *ngSwitchCase="'group'" class="list-row group-row" [class.expanded]="item.isExpanded"
            (click)="toggleExpansion(item)">
            <div class="list-content">
              <mat-checkbox *ngIf="showCheckboxes" [(ngModel)]="item.checked" [indeterminate]="item.indeterminate"
                (ngModelChange)="onGroupCheckboxChange(asGroup(item), $event)" (click)="$event.stopPropagation()"
                style="margin-bottom:0">
              </mat-checkbox>

              <ng-container *ngIf="showColorPickers">
                <input *ngIf="allowColorChange; else staticGroupColor" class="color-input"
                  [style.background]="item.color" [(colorPicker)]="item.color"
                  (colorPickerChange)="onParentColorChange(asGroup(item), $event)" [cpUseRootViewContainer]="true"
                  [cpPosition]="getPickerPosition(i)" [cpPositionRelativeToArrow]="true"
                  (click)="$event.stopPropagation()" readonly />
                <ng-template #staticGroupColor>
                  <div class="color-input static" [style.background]="item.color"></div>
                </ng-template>
              </ng-container>

              <span class="group-name">{{ item.name | titlecase }}</span>
            </div>
            <mat-icon class="chevron-icon">keyboard_arrow_down</mat-icon>
          </div>

          <div *ngSwitchCase="'subgroup'" class="list-row subgroup-row" [class.expanded]="item.isExpanded"
            (click)="toggleExpansion(item)">
            <div class="list-content">
              <mat-checkbox *ngIf="showCheckboxes" [(ngModel)]="item.checked" [indeterminate]="item.indeterminate"
                (ngModelChange)="onSubGroupCheckboxChange(asSubGroup(item), $event)" (click)="$event.stopPropagation()"
                style="margin-bottom:0">
              </mat-checkbox>

              <ng-container *ngIf="showColorPickers">
                <input *ngIf="allowColorChange; else staticSubGroupColor" class="color-input"
                  [style.background]="item.color" [(colorPicker)]="item.color"
                  (colorPickerChange)="onSubGroupColorChange(findParentGroup(asSubGroup(item))!, asSubGroup(item), $event)"
                  [cpUseRootViewContainer]="true" [cpPosition]="getPickerPosition(i)" [cpPositionRelativeToArrow]="true"
                  (click)="$event.stopPropagation()" readonly />
                <ng-template #staticSubGroupColor>
                  <div class="color-input static" [style.background]="item.color"></div>
                </ng-template>
              </ng-container>

              <span class="group-name">{{ item.name | titlecase}}</span>
            </div>
            <mat-icon class="chevron-icon">keyboard_arrow_down</mat-icon>
          </div>

          <div *ngSwitchCase="'reason'" class="list-row reason-row" [id]="'status-reason-' + item.code"
            (click)="onReasonRowClick(asReason(item))">
            <div class="list-content">
              <mat-checkbox *ngIf="showCheckboxes" [(ngModel)]="item.checked"
                (ngModelChange)="onReasonCheckboxChange(asReason(item), $event)" (click)="$event.stopPropagation()"
                style="margin-bottom:0">
              </mat-checkbox>

              <ng-container *ngIf="showColorPickers">
                <input *ngIf="allowColorChange; else staticReasonColor" class="color-input"
                  [style.background]="item.color" [(colorPicker)]="item.color"
                  (colorPickerChange)="onReasonColorChange(asReason(item), $event)" [cpUseRootViewContainer]="true"
                  [cpPosition]="getPickerPosition(i)" [cpPositionRelativeToArrow]="true"
                  (click)="$event.stopPropagation()" readonly />
                <ng-template #staticReasonColor>
                  <div class="color-input static" [style.background]="item.color"></div>
                </ng-template>
              </ng-container>

              <span class="reason-desc">{{ item.code }} - {{ item.desc | titlecase}}</span>
            </div>
          </div>

        </ng-container>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>